import React, { useState } from "react";
import config from "../../../config";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { menuItems } from "../../../menu-items";
import { IconBrandHipchat } from "@tabler/icons";

//Material UI
import {
  AppBar,
  Container,
  Toolbar,
  Typography,
  Box,
  Button,
  Tooltip,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  ClickAwayListener,
  ButtonBase,
  Stack,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import { Logout, NoEncryption, AccountCircle, Settings, Home, Search, FindInPage } from "@mui/icons-material";

import NavLogo from "./NavLogo";
import globalUseStyles from "../../../components/GlobalStyles";
import { themeColors } from "../../../theme/themeColors";
import Api from "../../../components/Api";
import axios from "axios";
import { useSelector } from "react-redux";

import { startCase, toLower } from "lodash";

const Navbar = () => {
  const { userInfo } = useSelector((state) => state.app);

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const navigate = useNavigate();
  // Add this near other state declarations
  const location = useLocation();

  // Add this helper function
  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (url) => {
    navigate(url);
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  // User Logout
  const handleUserLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");

    // const url = Api.logout;
    // const token = localStorage.getItem("token");
    // console.log("token", token);

    // const options = {
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `Token ${token}`,
    //   },
    // };

    // axios
    //   .post(url, {}, options)
    //   .then((res) => {
    //     localStorage.removeItem("token");
    //     navigate("/login");
    //   })
    //   .catch((error) => {
    //     localStorage.removeItem("token");
    //     navigate("/login");
    //   });
  };

  const globalClasses = globalUseStyles();
  return (
    <AppBar
      position="static"
      sx={{
        position: "relative",
        backgroundColor: "#ffffff",
        //borderBottom: `1px solid ${config.borderColor}`,
        boxShadow: "0 0 5px rgba(0,0,0,0.2)",
        py: 1,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters variant="regular" sx={{ justifyContent: "space-between" }}>
          {/* Desktop Logo - START */}
          <Box sx={{ display: { xs: "none", md: "flex" }, mr: 4 }}>
            <NavLogo />
          </Box>
          {/* Desktop Logo - END */}

          {/* Mobile Logo - START */}
          <Box sx={{ display: { xs: "flex", md: "none" }, flexGrow: 1 }}>
            <NavLogo />
          </Box>
          {/* Mobile Logo - END */}

          {/* Desktop Menu - START */}
          <Box sx={{ flexGrow: 0 }}>
            <Stack direction="row" spacing={1} sx={{ mr: 2 }}>
              <Button
                component={Link}
                to="/app/home"
                sx={{
                  px: 2,
                  py: 1,
                  borderRadius: 1,
                  textDecoration: "none",
                  color: isActiveRoute("/app/home") ? "primary.main" : "text.primary",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-house-icon lucide-house"
                  style={{ width: "18px", height: "18px", marginRight: "5px" }}
                >
                  <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
                  <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                </svg>
                Home
              </Button>
              <Button
                component={Link}
                to="/app/search"
                sx={{
                  my: 1,
                  mr: 1,
                  px: 2,
                  borderRadius: 1,
                  textDecoration: "none",
                  color: isActiveRoute("/app/search") ? "primary.main" : "text.primary",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-search-icon lucide-search"
                  style={{ width: "18px", height: "18px", marginRight: "5px" }}
                >
                  <path d="m21 21-4.34-4.34" />
                  <circle cx="11" cy="11" r="8" />
                </svg>
                HMDA
              </Button>

              <Button
                component="a"
                href="https://real-estate-leads.ongil.ai/app/dashboard"
                sx={{
                  my: 1,
                  mr: 1,
                  px: 2,
                  borderRadius: 1,
                  te24xtDecoration: "none",
                  color: "text.primary",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width=""
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chart-pie-icon lucide-chart-pie"
                  style={{ width: "18px", height: "18px", marginRight: "5px" }}
                >
                  <path d="M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z" />
                  <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
                </svg>
                Dashboard
              </Button>

              <IconButton onClick={handleOpenUserMenu} variant="outlined" color="grey.700">
                <AccountCircle sx={{ width: 28, height: 28 }} />
              </IconButton>
            </Stack>

            <Menu
              sx={{ mt: "45px", minWidth: "190px" }}
              id="profile-menu"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {/* <MenuItem sx={{ pointerEvents: "none" }}>
                <Box sx={{ minWidth: "190px" }}>
                  <Typography sx={{ fontSize: "15px", fontWeight: 600 }}>Hi, User</Typography>
                  <Typography component="span" sx={{ fontSize: "12px", color: "grey.600" }}>
                    &nbsp;
                  </Typography>
                </Box>
              </MenuItem>

              <Divider /> */}

              <MenuItem onClick={handleUserLogout}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </Box>
          {/* Desktop Menu - END */}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
